import { entryPointId } from 'settings/app/constants'

/**
 * sort orders for detail view && compare
 * @type {{HOSPITAL_WITH_OUT_TREATMENT_REASON: string[], DAYANDNIGHTCARE: string[], DOCTORS: string[], HOSPITAL_WITH_TREATMENT_REASON: string[], CAREHOMES: string[]}}
 */
export const ACCORDION_ORDER = {
  HOSPITAL_WITH_TREATMENT_REASON: [
    'locationInfo',
    'locations',
    'visitingHours',
    'slideshow',
    'quality',
    'qualityIndication',
    'qualityTransparency',
    'peq',
    'insuredBenefits',
    'roomFeatures',
    'childCare',
    'eatingHabits',
    'accessibility',
    'religiousOffers',
    'treatmentOptions',
    'doctors',
    'facts',
  ],
  HOSPITAL_WITH_OUT_TREATMENT_REASON: [
    'locationInfo',
    'locations',
    'visitingHours',
    'slideshow',
    'departmentsList',
    'quality',
    'qualityTransparency',
    'peq',
    'insuredBenefits',
    'doctors',
  ],
  DOCTORS: [
    'locationInfo',
    'businessHours',
    'slideshowOffice',
    'services',
    'qualifications',
    'qualityLabel',
    'insuredBenefits',
    'cooperations',
    'accessibility',
    'languages',
  ],
  CAREHOMES: [
    'facilityInformation',
    'locationInfo',
    'slideshowOffice',
    'prices',
    'homeContract',
    'qualityReport',
    'qualityManagement',
    'offers',
    'equipment',
    'accessibility',
    'mealInformation',
    'dailyRoutine',
    'visitingHours',
    'religiousOffers',
    'languages',
    'getToKnow',
    'insuredOffers',
    'cooperations',
    'pdfReport',
    'workplaceHealthPromotion',
  ],
  DAYANDNIGHTCARE: [
    'locationInfo',
    'businessHours',
    'slideshowOffice',
    'prices',
    'homeContract',
    'qualityReport',
    'qualityManagement',
    'offers',
    'equipment',
    'roomFeatures',
    'accessibility',
    'mealInformation',
    'dailyRoutine',
    'religiousOffers',
    'languages',
    'contactPersons',
    'insuredOffers',
    'cooperations',
  ],
  CARESERVICES: [
    'branches',
    'locationInfo',
    'slideshowOffice',
    'prices',
    'offers',
    'staff',
    'religiousOffers',
    'languages',
    'cooperations',
    // not in prototyp
    'homeContract',
    'qualityReport',
    'qualityManagement',
    'roomFeatures',
    'accessibility',
    'dailyPlanning',
    'visitingTimes',
    'insuredBenefits',
  ],
  CARESUPPORT: ['locationInfo', 'services', 'languages'],
}

/**
 * used to map titles to detailData keys
 */
export const ACCORDION_TITLES = {
  [entryPointId.DAYANDNIGHTCARE]: {
    // prices: 'costs',
    roomFeatures: 'roomFeaturesDayAndNightCare',
    insuredBenefits: 'insuredBenefitsDayAndNightCare',
    slideshowOffice: 'slideshowCarehomes',
  },
  [entryPointId.CARESERVICES]: {
    slideshowOffice: 'slideshowCareservice',
  },
  [entryPointId.CAREHOMES]: {
    locationInfo: 'locationInfoCarehomes',
    slideshowOffice: 'slideshowCarehomes',
  },
}

/**
 * used for detail views @GeneralInformation
 * search in 'info list' for string and scroll to accordion content
 * have to extend this config for more clickable header links
 *
 * scrollTo: target accordion key for scroll event
 * searchFor: arr of info labels for mapping scroll behavior
 * newLabel: will replace origin label
 *
 * @type {{hospitals: [{newLabel: string, searchFor: string[], scrollTo: string},{searchFor: string[], scrollTo: string}]}}
 */
export const SCROLL_TO_ACCORDION = {
  hospitals: [
    {
      scrollTo: 'quality',
      searchFor: ['QSR-Qualitätsbewertungen für den Eingriff'],
      newLabel: 'QSR-Qualitätsbewertungen liegen vor',
    },
    {
      scrollTo: 'insuredBenefits',
      searchFor: ['AOK-Vorteil'],
    },
  ],
}

/**
 * detail header (general information) show contribution
 * @type {(string)[]}
 */
export const DETAIL_HEADER_HAS_CONTRIBUTION = [
  entryPointId.CAREHOMES,
  entryPointId.DAYANDNIGHTCARE,
]
